import { corporateCMSApi } from "~/Services";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
export const generateFields = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[],
  idx1: number
): ModuleFields[] => {
  return languages.flatMap((lang) => [
    {
      fieldName: `Tab Name (${lang.code})`,
      fieldValue: `${basePath}.items[${idx1}].tab.name`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}.${basePath}.items[${idx1}].tab.name`,
      formType: "input",
      label: `Tab Name (${lang.code})`,
      placeholder: `Enter Tab Name ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Tab Name ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Body (${lang.code})`,
      fieldValue: `${basePath}.items[${idx1}].body`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}.${basePath}.items[${idx1}].body`,
      formType: "richText",
      label: `Body (${lang.code})`,
      placeholder: `Enter Body ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Body ${lang.code} is required` } : undefined,
    },
  ]);
};
export const generateMainContentFields = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[]
): ModuleFields[] => {
  return languages.flatMap((lang) => [
    {
      fieldName: `Latitude (${lang.code})`,
      fieldValue: `${basePath}.map.coordinates.lat`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_map_coordinates_lat`,
      formType: "input",
      label: `Latitude (${lang.code})`,
      placeholder: `Enter Latitude ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Latitude ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Longitude (${lang.code})`,
      fieldValue: `${basePath}.map.coordinates.lng`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_map_coordinates_lng`,
      formType: "input",
      label: `Longitude (${lang.code})`,
      placeholder: `Enter Longitude ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Longitude ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Description (${lang.code})`,
      fieldValue: `${basePath}.markup`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_markup`,
      formType: "richText",
      label: `Description (${lang.code})`,
      placeholder: `Enter Description ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Description ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Inquiries Description (${lang.code})`,
      fieldValue: `${basePath}.inquiriesMarkup`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_inquiriesMarkup`,
      formType: "richText",
      label: `Inquiries Description (${lang.code})`,
      placeholder: `Enter Inquiries Description ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Inquiries Description ${lang.code} is required` }
          : undefined,
    },
    {
      fieldName: `Address Markup (${lang.code})`,
      fieldValue: `${basePath}.addressMarkup`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_addressMarkup`,
      formType: "richText",
      label: `Address Markup (${lang.code})`,
      placeholder: `Enter Address Markup ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Address Markup ${lang.code} is required` }
          : undefined,
    },
    {
      fieldName: `Thank You text (${lang.code})`,
      fieldValue: `${basePath}.afterSubmitText.thankYouText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_afterSubmitText_thankYouText`,
      formType: "input",
      label: `Thank You text (${lang.code})`,
      placeholder: `Enter Thank You text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Thank You text ${lang.code} is required` }
          : undefined,
    },
    {
      fieldName: `Back to Form (${lang.code})`,
      fieldValue: `${basePath}.afterSubmitText.backToFrom`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_afterSubmitText_backToFrom`,
      formType: "input",
      label: `Back to Form (${lang.code})`,
      placeholder: `Enter Back to Form ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Back to Form ${lang.code} is required` } : undefined,
    },
  ]);
};
export const generateFormValueFields = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[]
): ModuleFields[] => {
  return languages.flatMap((lang) => [
    {
      fieldName: `Nature of Enquiry Values (${lang.code})`,
      fieldValue: `${basePath}.form.values.natureOfEnquiryValue`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_values_natureOfEnquiryValue`,
      formType: "multiInput",
      label: `Nature of Enquiry Values (${lang.code})`,
      placeholder: `Enter Nature of Enquiry Values ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Nature of Enquiry Values ${lang.code} is required` }
          : undefined,
    },
    {
      fieldName: `Industry Values (${lang.code})`,
      fieldValue: `${basePath}.form.values.industryValue`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_values_industryValue`,
      formType: "multiInput",
      label: `Industry Values (${lang.code})`,
      placeholder: `Enter Industry Values ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Industry Values ${lang.code} is required` }
          : undefined,
    },
    {
      fieldName: `Name Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.nameText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_nameText`,
      formType: "input",
      label: `Name Text (${lang.code})`,
      placeholder: `Enter Name Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Name Text ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Nature of Enquiry Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.natureOfEnquiryText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_natureOfEnquiryText`,
      formType: "input",
      label: `Nature of Enquiry Text (${lang.code})`,
      placeholder: `Enter Nature of Enquiry Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Nature of Enquiry Text ${lang.code} is required` }
          : undefined,
    },
    {
      fieldName: `Company Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.companyText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_companyText`,
      formType: "input",
      label: `Company Text (${lang.code})`,
      placeholder: `Enter Company Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Company Text ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Industry Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.industryText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_industryText`,
      formType: "input",
      label: `Industry Text (${lang.code})`,
      placeholder: `Enter Industry Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Industry Text ${lang.code} is required` }
          : undefined,
    },
    {
      fieldName: `Email Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.emailText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_emailText`,
      formType: "input",
      label: `Email Text (${lang.code})`,
      placeholder: `Enter Email Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Email Text ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Subject Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.subjectText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_subjectText`,
      formType: "input",
      label: `Subject Text (${lang.code})`,
      placeholder: `Enter Subject Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Subject Text ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Message Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.messageText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_messageText`,
      formType: "input",
      label: `Message Text (${lang.code})`,
      placeholder: `Enter Message Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Message Text ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Captcha Title Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.captcha.titleText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_captcha_titleText`,
      formType: "input",
      label: `Captcha Title Text (${lang.code})`,
      placeholder: `Enter Captcha Title Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Captcha Title Text ${lang.code} is required` }
          : undefined,
    },
    {
      fieldName: `Captcha Help Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.captcha.helpText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_captcha_helpText`,
      formType: "input",
      label: `Captcha Help Text (${lang.code})`,
      placeholder: `Enter Captcha Help Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Captcha Help Text ${lang.code} is required` }
          : undefined,
    },
    {
      fieldName: `New Captcha Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.captcha.newCaptchaText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_captcha_newCaptchaText`,
      formType: "input",
      label: `New Captcha Text (${lang.code})`,
      placeholder: `Enter New Captcha Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `New Captcha Text ${lang.code} is required` }
          : undefined,
    },
    {
      fieldName: `Submit Button Text (${lang.code})`,
      fieldValue: `${basePath}.form.labels.submitButtonText`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}_form_labels_submitButtonText`,
      formType: "input",
      label: `Submit Button Text (${lang.code})`,
      placeholder: `Enter Submit Button Text ${lang.code}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Submit Button Text ${lang.code} is required` }
          : undefined,
    },
  ]);
};
export const languages = [
  { code: "EN", label: "English", parseField: "field_content_english" },
  { code: "MS", label: "Malay", parseField: "field_content_malay" },
  { code: "ZH", label: "Mandarin", parseField: "field_content_mandarin" },
];
let url = `/api/page-content/all-fields?pageName=business/business-opportunities/commercial-leasing-opportunities`;
export let getData: { [key in ModuleConfig]: ModuleFields[] } | null = null;
const fetchProfileData = async (): Promise<{ [key in ModuleConfig]: ModuleFields[] } | null> => {
  try {
    const res = await corporateCMSApi.get(url);
    const profileData = res.data;
    const fields1 =
      profileData?.[0]?.field_content_english?.data?.items?.map((item: any, index: number) =>
        generateFields("data", languages, index)
      ) || [];
    const fields2 = generateMainContentFields("data", languages) || [];
    const fields3 = generateFormValueFields("data", languages) || [];
    return {
      commercialLeasingOpportunities: fields1 as ModuleFields[],
      commercialLeasingOpportunitiesMainContent: fields2 as ModuleFields[],
      commercialLeasingOpportunitiesFormValues: fields3 as ModuleFields[],
    };
  } catch (error) {
    return null;
  }
};
export const getCommercialLeasingOpportunitiesTabsDrillDownData = async () => {
  if (!getData) {
    getData = await fetchProfileData();
  }
  return getData;
};
